<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-layout class="justify-space-between align-end mb-4">
            <!-- se for somente racunho o título muda para Listagem de rascunhos -->
            <v-flex v-if="somenteRascunho" class="titulo">
                <h1 class="titulo">Listagem de Rascunhos</h1>
            </v-flex>
            <v-flex v-else class="titulo">
                <h1 class="titulo">Listagem de Contratos</h1>
            </v-flex>
            <div class="container_alterar_visualizacao">
                <v-btn color="primary" class="mr-4 mt-5" @click="aba_visualizacao_visivel = true">
                    <v-icon color="lightgray" class="mr-2">visibility</v-icon> Alterar Visualização
                </v-btn>
                <v-btn color="primary" class="mt-5" @click="show_dialog_colunas_fixas = true">
                    <v-icon color="lightgray">mdi-pin</v-icon> Fixar colunas
                </v-btn>
            </div>
        </v-layout>
        <DialogVincularContrato v-model="exibir_vincular_contrato" :hash-contrato-antigo="hash_contrato_antigo"
                                :id-pedido="id_pedido_vincular_contrato" v-if="exibir_vincular_contrato" @reloadDataTable="reload" />
        <DialogFixarColunas v-model="show_dialog_colunas_fixas" :table="tabelasColunasFixas.ContratosListagem" :columns="headersFixedComputed" :already-fixed-columns="columnsFixedsComputed" @reload="carregarCamposUsuario" />
        <DataTable
                url="/painel/contrato"
                :headers="headersComputed"
                :params="params"
                :filter="filter"
                item-key="id_pedido"
                show-select
                :silent="true"
                :value="contratos_selecionados"
                @input="setContratosSelecionados"
                :class="{ 'listagem': true, 'table-consultas-detalhadas': true, 'no-sale-date': !campos_usuario.data_venda }"
                ref="datatable"
                id="datatable_contratos"
                @filter="filterAction"
                @onLoad="loadAction"
                table-container
                :fixed-select="true"
                :hide-select-when-fixed="false"
                :overflow-y-visible="true"
                :overflow-x-scroll-visible="true"
        >
            <template v-slot:items="{item}">
                <template v-for="(coluna, index) in headersComputed">
                    <td v-bind:key="'actions-'+index" v-if="coluna.value === 'actions'" class="sticky-column actions-column">
                        <v-menu :close-on-content-click="false">
                            <template v-if="showMenuOptions(item)" v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" class="btn-acoes" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>

                            <v-list v-if="!!item.id_carrinho && (item.row_num !== undefined || somenteRascunho)">
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!somenteRascunho" @click="acessarDetalhesCarrinho(item.id_carrinho)">
                                    <v-list-item-title>
                                        <v-icon class="mr-2">mdi-eye-outline</v-icon>Detalhes do
                                        Carrinho
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="somenteRascunho" @click="excluirRascunho(item)">
                                    <v-list-item-title>Excluir</v-list-item-title>
                                </v-list-item>
                            </v-list>

                            <v-list v-else-if="somenteRascunho && !item.id_carrinho && !item.row_num">
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="excluirRascunho(item)">
                                    <v-list-item-title>Excluir</v-list-item-title>
                                </v-list-item>
                            </v-list>

                            <v-list v-else>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirVisualizarDocumentosDocusign(item)"
                                             @click="visualizarDocumentosDocusign(item)">
                                    <v-menu :close-on-content-click="false"
                                            @input="aberto => limparContratos(aberto, item.id_contrato)">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-list-item-title v-on="on" v-bind="attrs">
                                                Visualizar Documentos
                                            </v-list-item-title>
                                        </template>
                                        <v-list>
                                            <v-list-item v-if="documentos_visualizar.length === 0">
                                                <v-list-item-title>Carregando...</v-list-item-title>
                                            </v-list-item>
                                            <template v-else>
                                                <v-list-item v-for="documento in documentos_visualizar" :key="documento"
                                                             @click="visualizarDocumentoDocusign(item.hash_contrato, documento)">
                                                    <v-list-item-title>{{ documento }}</v-list-item-title>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </v-menu>
                                </v-list-item>
                                <v-list-item v-if="exibirVisualizarDocumentosAC(item)"
                                             @click="visualizarDocumentosAC(item)">
                                    <v-list-item-title>Visualizar Documentos</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirCompartilharDocumentos(item)"
                                             @click="compartilharContratos([item])">
                                    <v-list-item-title>Compartilhar documentos</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirReenviarEmail(item)" @click="reenviarContratos([item], false)">
                                    <v-list-item-title>Reenviar contrato para assinatura</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirEnviarContrato(item)" @click="enviarContratos([item])">
                                    <v-list-item-title>Enviar contrato</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirLiberarAssinatura(item)" @click="liberarAssinatura(item)">
                                    <v-list-item-title>Liberar assinatura obrigatória</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirQuandoFalhaAlocacao(item)"
                                             @click="alterarStatusPedidoAlocado(item, 'Enviado')">
                                    <V-list-item-title>Alterar status da Venda para Venda Realizada</V-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirQuandoFalhaAlocacao(item)"
                                             @click="alterarStatusPedidoAlocado(item, 'N')">
                                    <V-list-item-title>Alterar status da Venda para Aguardando Pagamento</V-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirQuandoFalhaAlocacao(item)" @click="checarAlocacao(item)">
                                    <v-list-item-title>Checar Alocação</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirBuscarStatusContrato(item)" @click="buscarStatusContrato(item)">
                                    <V-list-item-title>Buscar status do contrato</V-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirRecriarContrato(item)" @click="recriarContrato(item)">
                                    <V-list-item-title>Recriar contrato</V-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="exibirVincularContrato(item)" @click="vincularContrato(item)">
                                    <V-list-item-title>Vincular contrato</V-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                    <td v-bind:key="index" v-else-if="coluna.value != 'cotas_multiplas'" :class="`${columnsFixedsComputed.includes(coluna.value) ? 'sticky-column' : ''}`" :style="`${columnsFixedsComputed.includes(coluna.value) ? `left: ${150*(index)}px;min-width:150px;` : ''}`">{{ formaDataTable(coluna.value, item, somenteRascunho).text }}</td>
                    <td v-bind:key="-index" v-else :class="'flex text-center flex-basis-0 center-icon'+(`${columnsFixedsComputed.includes(coluna.value) ? 'sticky-column' : ''}`)" :style="`${columnsFixedsComputed.includes(coluna.value) ? `left: ${150*(index)}px;min-width:150px;` : ''}`">
                        <v-icon size="20" class="mr-1" :color="!!item.cotas_multiplas ? 'success' : 'error'">
                            {{
                                !!item.cotas_multiplas ?
                                    "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span :style="{ color: item.cotas_multiplas ? 'var(--success)' : 'var(--error)' }">
                            {{ !!item.cotas_multiplas ? 'Sim' : 'Não' }}
                        </span>
                    </td>
                </template>
            </template>
        </DataTable>
        <TabDialog ref="TabDialog" title="Alterar Visualização" v-model="aba_visualizacao_visivel">
            <p class="text--dark my-4">Selecione abaixo as colunas que deseja visualizar na listagem:</p>
            <v-checkbox v-model="campos_alterar_visualizacao.id_carrinho" label="ID Carrinho" />
            <v-checkbox v-model="campos_alterar_visualizacao.data_venda" label="Data venda" />
            <v-checkbox v-model="campos_alterar_visualizacao.qtd_cotas_carrinho" label="Qtd. cotas" />
            <v-checkbox v-model="campos_alterar_visualizacao.cotas_multiplas" label="Cotas multiplicadas?" />
            <v-checkbox v-model="campos_alterar_visualizacao.nome_cliente" label="Nome do cliente" />
            <v-checkbox v-model="campos_alterar_visualizacao.cpf_cnpj_cliente" label="CPF/CNPJ do cliente" />
            <v-checkbox v-model="campos_alterar_visualizacao.email_cliente" label="E-mail" />
            <v-checkbox v-model="campos_alterar_visualizacao.cd_cota" label="N° da Cota" />
            <v-checkbox v-model="campos_alterar_visualizacao.cd_simulacao_ed" label="Cód. Simulador" />
            <v-checkbox v-model="campos_alterar_visualizacao.status_alocacao" label="Status da Cota" />
            <v-checkbox v-model="campos_alterar_visualizacao.grupo" label="Grupo da Cota" />
            <v-checkbox v-model="campos_alterar_visualizacao.numero_reserva" label="Nº da reserva" />
            <v-checkbox v-model="campos_alterar_visualizacao.status_venda" label="Status da venda" />
            <v-checkbox v-if="!somenteRascunho" v-model="campos_alterar_visualizacao.status_contrato" label="Status do contrato" />
            <v-checkbox v-model="campos_alterar_visualizacao.bem" label="Bem" />
            <v-checkbox v-model="campos_alterar_visualizacao.valor_bem" label="Valor do bem" />
            <v-checkbox v-model="campos_alterar_visualizacao.tipo_cota" label="Tipo de Cota" />
            <v-checkbox v-model="campos_alterar_visualizacao.plano_venda" label="Nome do plano de venda" />
            <v-checkbox v-model="campos_alterar_visualizacao.marca" label="Marca" />
            <v-checkbox v-model="campos_alterar_visualizacao.unidade_negocio" label="Un. Negócio Logado" />
            <v-checkbox v-model="campos_alterar_visualizacao.pz_comercializacao" label="Prazo" />
            <v-checkbox v-model="campos_alterar_visualizacao.forma_pagamento" label="Forma de Pagamento" />
            <v-checkbox v-if="!somenteRascunho" v-model="campos_alterar_visualizacao.codigo_pagamento" label="Cód. Pagamento" />
            <v-checkbox v-model="campos_alterar_visualizacao.perfil_comercial" label="Hierarquia Comercial" />
            <v-checkbox v-model="campos_alterar_visualizacao.id_usuario_venda" label="Usuário" />
            <v-checkbox v-model="campos_alterar_visualizacao.cd_ponto_venda" label="Código P.V" />
            <v-checkbox v-model="campos_alterar_visualizacao.nm_ponto_venda" label="Nome P.V" />
            <v-checkbox v-model="campos_alterar_visualizacao.cpf_cnpj_pv" label="CPF/CNPJ P.V" />
            <v-checkbox v-model="campos_alterar_visualizacao.comissionado" label="Comissionado" />
            <v-checkbox v-model="campos_alterar_visualizacao.backoffice" label="Venda backoffice" />
            <v-checkbox v-model="campos_alterar_visualizacao.empresa" label="Empresa" />
            <v-checkbox v-if="!somenteRascunho" v-model="campos_alterar_visualizacao.status_pagamento" label="Status do Pagamento" />
            <v-checkbox v-model="campos_alterar_visualizacao.negociacao_furo" label="Negociação furo" />
            <v-checkbox v-if="!somenteRascunho" v-model="campos_alterar_visualizacao.hash_contrato" label="Id contrato" />
            <v-checkbox v-model="campos_alterar_visualizacao.origem_venda" label="Origem da Venda" />
            <v-checkbox v-model="campos_alterar_visualizacao.origem_acesso" label="Origem Acesso" />
            <v-checkbox v-if="!somenteRascunho" v-model="campos_alterar_visualizacao.origem_assinatura_consorcio" label="Origem Contrato" />
            <v-checkbox v-model="campos_alterar_visualizacao.cd_plano_venda" label="Cód. Plano de Venda" />
            <v-checkbox v-model="campos_alterar_visualizacao.tipo_indice" label="Tipo de Índice" />
            <v-checkbox v-model="campos_alterar_visualizacao.categoria_plano" label="Categoria do Plano" />
            <v-checkbox v-model="campos_alterar_visualizacao.tipo_grupo" label="Tipo de Grupo" />

            <div slot="footer" class="d-flex row-padding">
                <v-flex class="col flex-basis-0">
                    <v-btn color="secondary" block @click="restaurarVisualizacao">Restaurar Configurações</v-btn>
                </v-flex>
                <v-flex class="col flex-basis-0">
                    <v-btn color="primary" block @click="aplicarAlteracoesVisualizacao">Aplicar</v-btn>
                </v-flex>
            </div>
        </TabDialog>
        <v-row class="botoes-acao">
            <v-col style="margin-top: 24px;">
                <v-btn :block="!somenteRascunho" x-small color="primary" class="py-4" @click="exportarExcel">{{ somenteRascunho ? 'Download da listagem de rascunhos' : 'Download da listagem' }}</v-btn>
            </v-col>
            <v-col v-if="!somenteRascunho">
                <div class="d-flex justify-end tooltip-ajuda">
                    <v-icon>mdi-help-circle-outline</v-icon>
                    <p class="tooltip-ajuda-text">
                        Marque ao menos 1 proposta com status do contrato ‘assinado’ para
                        enviar todos
                        os documentos dos envelopes
                    </p>
                </div>
                <v-btn block x-small color="primary" class="py-4" :disabled="!compartilhar_documentos_habilitado"
                       @click="compartilharContratos(contratos_para_compartilhar)">
                    Compartilhar documentos
                </v-btn>
            </v-col>
            <v-col v-if="!somenteRascunho">
                <div class="d-flex justify-end tooltip-ajuda">
                    <v-icon>mdi-help-circle-outline</v-icon>
                    <p class="tooltip-ajuda-text">
                        Marque ao menos 1 proposta com status do contrato ‘pendente’ para
                        reenviar a
                        solicitação de assinatura
                    </p>
                </div>
                <v-btn block x-small color="secondary" class="py-4" :disabled="!reenviar_contratos_habilitado"
                       @click="reenviarContratos(contratos_para_reenviar, true)">
                    Reenviar contratos para assinatura
                </v-btn>
            </v-col>
            <v-col v-if="!somenteRascunho">
                <div class="d-flex justify-end tooltip-ajuda">
                    <v-icon>mdi-help-circle-outline</v-icon>
                    <p class="tooltip-ajuda-text">
                        Marque ao menos 1 proposta com status do contrato ‘falha’ para gerar e
                        enviar
                        o contrato
                    </p>
                </div>
                <v-btn block x-small color="primary" class="py-4" :disabled="!enviar_contatos_habilitado"
                       @click="enviarContratos(contratos_para_enviar)">
                    Enviar contratos
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import { TipoPessoa, OpcoesFuroDesc, StatusContrato, StatusPedidoDesc, StatusPedido, FormasPagamentoDesc, TIPOS_PROVEDOR_CONTRATO_DESC } from '@/plugins/constants'
  import { alert, notification, asyncConfirmationDialog, calcPercentage, verifyIfPaidAndReturnInText, getDescricaoStatusContrato } from '@/plugins/helpers'
  import { mapState } from 'vuex'
  import { get } from 'lodash'
  import * as Qs from 'qs'
  import DialogVincularContrato from '../../../dialogs/DialogVincularContrato'
  import editarVendasMixin from '@/mixins/editarVendasMixin'
  import { StatusAlocacoes, getStatusAlocacaoDesc } from '../../../plugins/status_alocacoes'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import DialogFixarColunas from '@/dialogs/DialogFixarColunas'
  import { tabelasColunasFixas } from '@/plugins/constants/nomes_tabelas_colunas_fixas'
  import { toDateBR, formatarCpfCnpj } from '@/plugins/formatters'
  import { changeDataTableScrollSizeOnHoverByRef } from '@/plugins/scrollSize'

  const MAX_CONTRATOS = 15
  export default {
    name: 'Listagem',
    components: { DialogVincularContrato, DialogFixarColunas },
    mixins: [editarVendasMixin],
    props: {
      filter: { type: Object, required: true },
      customFilter: { type: Object, required: true },
      idDocumento: { type: String },
      somenteRascunho: { type: Boolean, required: true, default: false }
    },
    data: () => ({
      tabelasColunasFixas,
      headers: [
        { text: 'Ações' }
      ],
      scrollLeftPorcentagePosition: 0,
      contratos_selecionados: [],
      documentos_visualizar: [],
      aba_visualizacao_visivel: false,
      show_dialog_colunas_fixas: false,
      campos_alterar_visualizacao: {
        data_venda: true,
        status_venda: true,
        status_alocacao: true,
        status_contrato: true,
        nome_cliente: true,
        cpf_cnpj_cliente: true,
        email_cliente: true,
        cd_cota: true,
        grupo: true,
        plano_venda: true,
        bem: true,
        valor_bem: true,
        tipo_cota: true,
        pz_comercializacao: true,
        numero_reserva: true,
        negociacao_furo: true,
        codigo_pagamento: true,
        perfil_comercial: true,
        id_usuario_venda: true,
        ponto_venda: true,
        cd_ponto_venda: true,
        nm_ponto_venda: true,
        cpf_cnpj_pv: true,
        id_carrinho: true,
        qtd_cotas_carrinho: true,
        cotas_multiplas: true,
        comissionado: true,
        backoffice: true,
        empresa: true,
        unidade_negocio: true,
        hash_contrato: true,
        origem_acesso: true,
        cd_simulacao_ed: true,
        marca: true,
        origem_venda: true,
        forma_pagamento: true,
        status_pagamento: true,
        origem_assinatura_consorcio: true,
        cd_plano_venda: true,
        tipo_indice: true,
        categoria_plano: true,
        tipo_grupo: true
      },
      campos_usuario: {
        data_venda: true,
        status_venda: true,
        status_alocacao: true,
        status_contrato: true,
        nome_cliente: true,
        cpf_cnpj_cliente: true,
        email_cliente: true,
        cd_cota: true,
        grupo: true,
        plano_venda: true,
        bem: true,
        valor_bem: true,
        tipo_cota: true,
        pz_comercializacao: true,
        numero_reserva: true,
        negociacao_furo: true,
        codigo_pagamento: true,
        perfil_comercial: true,
        id_usuario_venda: true,
        ponto_venda: true,
        cd_ponto_venda: true,
        nm_ponto_venda: true,
        cpf_cnpj_pv: true,
        id_carrinho: true,
        qtd_cotas_carrinho: true,
        cotas_multiplas: true,
        comissionado: true,
        backoffice: true,
        empresa: true,
        unidade_negocio: true,
        hash_contrato: true,
        origem_acesso: true,
        cd_simulacao_ed: true,
        marca: true,
        origem_venda: true,
        forma_pagamento: true,
        status_pagamento: true,
        origem_assinatura_consorcio: true,
        cd_plano_venda: true,
        tipo_indice: true,
        categoria_plano: true,
        tipo_grupo: true
      },
      exibe_reenvio_whatsapp: false,
      exibir_vincular_contrato: false,
      hash_contrato_antigo: 0,
      id_pedido_vincular_contrato: 0,
      colunasFixas: []
    }),
    computed: {
      headersComputed () {
        return this.headers.map((header, index) => {
          if (this.colunasFixas.includes(header.value)) {
            return {

              ...header,
              class: `fixed-column-${index}`
            }
          }
          return header
        })
      },
      headersFixedComputed () {
        const headersToFixed = this.headers.filter(val => val.value !== 'actions')
        return headersToFixed
      },
      columnsFixedsComputed () {
        const headersToFixed = this.colunasFixas
        headersToFixed.shift()
        return headersToFixed
      },
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'tb_pedido.data_venda',
            descending: true
          },
          custom_filter: this.customFilter,
          id_documento: this.idDocumento,
          somente_rascunho: this.somenteRascunho
        }
      },
      TipoPessoa: () => TipoPessoa,
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      StatusPedidoDesc: () => StatusPedidoDesc,
      FormasPagamentoDesc: () => FormasPagamentoDesc,
      formatarCpfCnpj,
      contratos_para_compartilhar () {
        return this.contratos_selecionados.filter(this.exibirCompartilharDocumentos)
      },
      contratos_para_reenviar () {
        return this.contratos_selecionados.filter(this.exibirReenviarEmail)
      },
      contratos_para_enviar () {
        return this.contratos_selecionados.filter(this.exibirEnviarContrato)
      },
      compartilhar_documentos_habilitado () {
        return this.contratos_para_compartilhar.length > 0
      },
      reenviar_contratos_habilitado () {
        return this.contratos_para_reenviar.length > 0
      },
      enviar_contatos_habilitado () {
        return this.contratos_para_enviar.length > 0
      },
      ...mapState(['super_admin'])
    },
    watch: {
      aba_visualizacao_visivel (show) {
        if (show) {
          Object.assign(this.campos_alterar_visualizacao, this.campos_usuario)
        }
        this.$refs.TabDialog.TravarScroll(show)
      }
    },
    mounted () {
      const wrapper = this.$refs.datatable?.$el?.querySelector('.v-data-table__wrapper')
      const container = this.$refs.datatable?.$el
      changeDataTableScrollSizeOnHoverByRef(wrapper, container)
      this.exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')

      this.carregarCamposUsuario()
    },
    methods: {
      toDateBR,
      formaDataTable (column, item, somenteRascunho) {
        switch (column) {
          case 'data_venda':
            return { class: 'somente-rascunho', text: this.toDateBR(item.data_venda) }
          case 'id_carrinho':
            return { class: '', text: item.id_carrinho || '-' }
          case 'qtd_cotas_carrinho':
            return { class: '', text: item.qtd_cotas_carrinho }
          case 'status_pedido':
            return { class: '', text: this.getStatusVenda(item.status_pedido) }
          case 'status_alocacao':
            return { class: '', text: this.getStatusAlocacaoDesc(item.status_alocacao) }
          case 'status_contrato':
            if (!somenteRascunho) {
              return { class: '', text: this.getDescricaoStatusContrato(item.status, item.docusign_falha, item.docusign_enviado) }
            }
            break
          case 'hash_contrato':
            if (!somenteRascunho) {
              return { class: '', text: item.hash_contrato || '-' }
            }
            break
          case 'nome_cliente':
            return { class: '', text: item.nome_assinante || '-' }
          case 'cpf_cnpj_cliente':
            return { class: '', text: item.pessoa === TipoPessoa.Fisica ? (item.cpf || '-') : (item.cnpj || '-') }
          case 'email_cliente':
            return { class: '',
                     text: item.status ? (item.email_assinante || '-') : (item.email_instancia
                       ? item.email_instancia
                       : item.email || '-') }
          case 'cd_cota':
            return { class: '', text: item.cd_cota || '-' }
          case 'cd_simulacao_ed':
            return { class: '', text: item.cd_simulacao_ed || '-' }
          case 'grupo':
            return { class: '', text: item.cd_grupo || '-' }
          case 'plano_venda':
            return { class: '', text: item.nome_plano || '-' }
          case 'bem':
            return { class: '', text: item.nome_bem || '-' }
          case 'valor_bem':
            return { class: '', text: item.valor_bem || '-' }
          case 'tipo_cota':
            return { class: '', text: this.getTipoCotaText(item.cd_tipo_cota, item.tipo_cota) }
          case 'pz_comercializacao':
            return { class: '', text: item.pz_comercializacao || '-' }
          case 'numero_reserva':
            return { class: '', text: item.id_reserva || '-' }
          case 'negociacao_furo':
            return { class: '', text: OpcoesFuroDesc[item.opcao_furo] || '-' }
          case 'forma_pagamento':
            return { class: '', text: this.getFormasPagamento(item.forma_pagamento) }
          case 'status_pagamento':
            if (!somenteRascunho) {
              return { class: '', text: this.getStatusPagamento(item.status_pedido) }
            }
            break
          case 'codigo_pagamento':
            if (!somenteRascunho) {
              return { class: '', text: item.codigo_pagamento_cliente || '-' }
            }
            break
          case 'perfil_comercial':
            return { class: '', text: item.perfil_comercial || '-' }
          case 'id_usuario_venda':
            return { class: '', text: item.login || '-' }
          case 'cd_ponto_venda':
            return { class: '', text: item.cd_ponto_venda }
          case 'nm_ponto_venda':
            return { class: '', text: item.nm_ponto_venda }
          case 'cpf_cnpj_pv':
            return { class: '', text: formatarCpfCnpj(item.cpf_cnpj_pv) }
          case 'comissionado':
            return { class: '', text: item.cd_comissionado }
          case 'backoffice':
            return { class: '', text: item.backoffice ? 'Sim' : 'Não' }
          case 'empresa':
            return { class: '', text: `${item.id_empresa} - ${item.nm_empresa}` }
          case 'marca':
            return { class: '', text: item.marca || '-' }
          case 'unidade_negocio':
            return { class: '', text: `${item.cd_unidade_negocio ? item.cd_unidade_negocio : ''} - ${item.nm_unidade_negocio ? item.nm_unidade_negocio : ''}` }
          case 'origem_venda':
            return { class: 'text-capitalize', text: item.origem_venda || '-' }
          case 'origem_acesso':
            return { class: '', text: (item.origem_acesso ? item.origem_acesso : 'Não definido') }
          case 'origem_assinatura_consorcio':
            if (!somenteRascunho) {
              return { class: '', text: this.obterTextoContratoEngine(item.origem_assinatura_consorcio) }
            }
            break
          case 'cd_plano_venda':
            return { class: '', text: item.cd_plano_venda || '-' }
          case 'tipo_indice':
            return { class: '', text: item.tipo_indice || '-', style: 'text-transform: uppercase;' }
          case 'categoria_plano':
            return { class: '', text: item.categoria_plano || '-' }
          case 'tipo_grupo':
            return { class: '', text: item.tipo_grupo || '-' }
          case 'id_documento':
            if (!somenteRascunho) {
              return { class: '', text: this.getIDDocumento(item.id_documento, item.id_carrinho, item.row_num !== undefined) }
            }
            break
          default:
            return { class: 'text-center', text: '-' }
        }
      },
      openFixarColunasDialog () {
        this.show_dialog_colunas_fixas = true
      },
      aplicarOrdemDasColunas () {
        const fixas = this.headers.filter(col => this.colunasFixas.includes(col.value)) // exemplo: 'Ações'
        fixas.forEach((val, index) => {
          this.campos_usuario[val.value] = true
        })

        // Adiciona o restante das colunas (que o backend não mandou)
        const restantes = this.headers.filter(
          col => col.value && !this.colunasFixas.includes(col.value)
        )

        this.headers = [...fixas, ...restantes]
        this.reload()
      },
      async loadFixedFields () {
        await this.$http.get(`/painel/fixed/fields/lists?table=${tabelasColunasFixas.ContratosListagem}`)
          .then(data => {
            data = data.data
            this.colunasFixas = []
            if (data.ok && (data.colunas?.length > 0)) {
              this.colunasFixas.push('actions')
              data.colunas.forEach(val => {
                this.colunasFixas.push(val.nome_campo)
              })
            } else {
              this.colunasFixas = [
                'actions',
                'data_venda',
                'id_documento',
                'id_carrinho'
              ]
            }
            this.aplicarOrdemDasColunas()
          }).catch(e => {
            this.colunasFixas = [
              'actions',
              'data_venda',
              'id_documento',
              'id_carrinho'
            ]
          })
      },
      getStatusAlocacaoDesc,
      getDescricaoStatusContrato,
      possuiAcaoPropostaIndividual (item) {
        return this.exibirVisualizarDocumentosAC(item) || this.exibirCompartilharDocumentos(item) || this.exibirReenviarEmail(item) || this.exibirEnviarContrato(item) || this.exibirLiberarAssinatura(item) || this.exibirQuandoFalhaAlocacao(item) || this.exibirQuandoFalhaAlocacao(item) || this.exibirQuandoFalhaAlocacao(item) || this.exibirBuscarStatusContrato(item) || this.exibirRecriarContrato(item) || this.exibirVincularContrato(item)
      },
      acessarDetalhesCarrinho (id_carrinho) {
        this.$emit('atualizaFiltroCarrinho', id_carrinho)
      },
      getIDDocumento (id_documento, id_carrinho, isView) {
        if (id_carrinho && isView) {
          return 'Múltiplas cotas'
        }
        return id_documento
      },
      filterAction () {
        const tableWrapper = document.querySelector('#datatable_contratos > div.v-data-table__wrapper')
        const scrollAtual = tableWrapper.scrollLeft
        const scrollTotal = tableWrapper.scrollWidth
        this.scrollLeftPorcentagePosition = calcPercentage(scrollAtual, scrollTotal)
      },
      loadAction () {
        this.$nextTick(() => {
          let tableWrapper = document.querySelector('#datatable_contratos > div.v-data-table__wrapper')
          const scrollTotal = tableWrapper.scrollWidth
          tableWrapper.scrollLeft = (scrollTotal / 100) * this.scrollLeftPorcentagePosition
        })
      },
      exibirVincularContrato (contrato) {
        return [
          StatusContrato.ContratoPendente,
          StatusContrato.ContratoCancelado,
          StatusContrato.ContratoRejeitado].includes(contrato.status) || (contrato.status === StatusContrato.ContratoFalha || contrato.docusign_falha)
      },
      exibirRecriarContrato (contrato) {
        return [
          StatusContrato.ContratoPendente,
          StatusContrato.ContratoCancelado,
          StatusContrato.ContratoRejeitado].includes(contrato.status)
      },
      exibirBuscarStatusContrato (contrato) {
        return [
          StatusContrato.ContratoPendente,
          StatusContrato.ContratoAssinado,
          StatusContrato.ContratoCancelado,
          StatusContrato.ContratoRejeitado].includes(contrato.status)
      },
      exibirQuandoFalhaAlocacao (contrato) {
        return contrato.status_alocacao === StatusAlocacoes.FalhaAlocacao || contrato.status_pedido === StatusPedido.FalhaAlocacao
      },
      exibirVisualizarDocumentosDocusign (contrato) {
        return [
          StatusContrato.ContratoPendente,
          StatusContrato.ContratoAssinado,
          StatusContrato.ContratoCancelado].includes(contrato.status) && !contrato.origem_assinatura_consorcio
      },
      exibirVisualizarDocumentosAC (contrato) {
        return [
          StatusContrato.ContratoPendente,
          StatusContrato.ContratoRejeitado,
          StatusContrato.ContratoAssinado,
          StatusContrato.ContratoCancelado].includes(contrato.status) && contrato.origem_assinatura_consorcio
      },
      exibirCompartilharDocumentos (contrato) {
        return contrato.status === StatusContrato.ContratoAssinado
      },
      exibirReenviarEmail (contrato) {
        return contrato.status === StatusContrato.ContratoPendente
      },
      exibirEnviarContrato (contrato) {
        return (contrato.status === StatusContrato.ContratoFalha || contrato.docusign_falha)
      },
      exibirLiberarAssinatura (contrato) {
        return contrato.assinatura_obrigatoria && !(contrato.status === StatusContrato.ContratoAssinado) &&
          (contrato.status_pedido === StatusPedido.AguardandoAssinaturaContrato ||
            contrato.status_pedido === StatusPedido.AguardandoAssinaturaContratoAlocacao ||
            contrato.status_pedido === StatusPedido.Pago)
      },
      setContratosSelecionados (val) {
        if (val.length > MAX_CONTRATOS) {
          alert(`Só é permitido selecionar no máximo ${MAX_CONTRATOS} contratos`)
          this.contratos_selecionados = [...this.contratos_selecionados]
        } else {
          this.contratos_selecionados = val
        }
      },
      visualizarDocumentoDocusign (hash_contrato, documento) {
        window.open(`${this.ws}/contrato/baixar/${hash_contrato}/${documento}`)
      },
      limparContratos (aberto, id_contrato) {
        if (!aberto && this.documentos_visualizar.length > 0) {
          this.documentos_visualizar = []
          setTimeout(async () => {
            this.$http.delete(`/contrato/documentos/${id_contrato}`)
          }, 500)
        }
      },
      compartilharContratos (contratos) {
        alert({
          text: 'Atenção! Deseja compartilhar todos os documentos do(s) contrato(s) via e-mail?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              const requests = contratos.map(contrato => this.$http.post(`/contrato/compartilhar/${contrato.id_contrato}`))
              notification(AlertTypes.SUCCESS, 'Contrato(s) agendado(s) para compartilhamento com sucesso!')
              await Promise.all(requests)
            }
          }
        })
      },
      async visualizarDocumentosDocusign (contrato) {
        try {
          const { data } = await this.$http.get(`/contrato/documentos/${contrato.hash_contrato}`)
          this.documentos_visualizar = data
        } catch (e) {
          const status_code = get(e, 'response.status', 500)
          if (status_code === 404) {
            notification(AlertTypes.ERROR, 'Falha ao identificar documentos da proposta. Tente novamente mais tarde.')
          } else {
            notification(AlertTypes.ERROR, e, 'Não foi possível visualizar os documentos')
          }
        }
      },
      async visualizarDocumentosAC (contrato) {
        try {
          let url = ''
          if (contrato.status === StatusContrato.ContratoPendente) {
            const { data } = await this.$http.get(`/contrato/visualizarpdfpendente/${contrato.hash_contrato}`)
            url = data[0].url
          } else {
            const { data } = await this.$http.get(`/contrato/documentos_assinatura_consorcio/${contrato.hash_contrato}`)
            url = data[0].url
          }

          if (url) {
            window.open(url, '_blank') // Abre o PDF em uma nova aba
          } else {
            notification(AlertTypes.ERROR, 'URL do documento não encontrada.')
          }
        } catch (e) {
          const status_code = get(e, 'response.status', 500)
          if (status_code === 404) {
            notification(AlertTypes.ERROR, 'Falha ao identificar documentos da proposta. Tente novamente mais tarde.')
          } else {
            notification(AlertTypes.ERROR, e, 'Não foi possível visualizar os documentos')
          }
        }
      },
      async reenviarContratos (contratos, fromButton = false) {
        const isSuperAdmin = this.$session.get('super_admin') === 1

        if (fromButton && !isSuperAdmin) {
          alert({
            text: 'Deseja reenviar o contrato para assinatura via e-mail?',
            showCloseButton: true,
            buttons: {
              'Fechar': () => true,
              'Sim': async () => {
                try {
                  await this.$http.post('/painel/contrato/reenviar', { contratos })
                  notification('info', 'E-mail(s) de solicitação de assinatura agendado(s) para reenvio com sucesso!')
                } catch (e) {
                  const data = e.response && e.response.data ? e.response.data : {}
                  const errorMessage = data.message || data.error || ''
                  const finalMessage = errorMessage || 'Não foi possível reenviar o contrato por e-mail.'

                  notification(AlertTypes.ERROR, finalMessage)
                }
              }
            }
          })
        } else {
          const buttons = {
            'E-mail': async () => {
              try {
                await this.$http.post('/painel/contrato/reenviar', { contratos })
                notification(AlertTypes.INFO, 'E-mail(s) de solicitação de assinatura agendado(s) para reenvio com sucesso!')
              } catch (e) {
                const data = e.response && e.response.data ? e.response.data : {}
                const errorMessage = data.message || data.error || ''
                const finalMessage = errorMessage || 'Não foi possível reenviar o contrato por e-mail.'

                notification(AlertTypes.ERROR, finalMessage)
              }
            }
          }

          if (isSuperAdmin || this.exibe_reenvio_whatsapp) {
            buttons['WhatsApp'] = async () => {
              try {
                const clientes_aceitaram_comunicacao_wpp = contratos.filter(contrato => contrato.aceita_comunicacao_whatsapp)
                const todos_clientes_aceitaram_comunicacao_wpp = contratos.length === clientes_aceitaram_comunicacao_wpp.length

                if (contratos.length === 1 && clientes_aceitaram_comunicacao_wpp.length === 0) {
                  notification(AlertTypes.WARN, 'A proposta selecionada não está autorizada pelo consorciado para contatá-lo via WhatsApp!')
                  return
                } else if (clientes_aceitaram_comunicacao_wpp.length === 0) {
                  notification(AlertTypes.WARN, 'Todas as propostas pendentes de assinatura selecionadas não estão autorizadas pelo consorciado para contatá-lo via WhatsApp!')
                  return
                } else if (!todos_clientes_aceitaram_comunicacao_wpp) {
                  const prosseguir = await asyncConfirmationDialog('Existem propostas selecionadas que não estão autorizadas pelo consorciado para contatá-lo via WhatsApp. Deseja prosseguir com a ação?')
                  if (!prosseguir) {
                    return
                  }
                }
                await this.$http.post('/painel/contrato/reenviar-whatsapp', { contratos: clientes_aceitaram_comunicacao_wpp }).then((response) => {
                  for (let mensagem of response.data.msgStack) {
                    notification(mensagem.type, mensagem.message)
                  }
                  if (response.data.msgStack && response.data.msgStack.some(msg => msg.type === 'info')) {
                    return
                  }

                  const telefoneCliente = clientes_aceitaram_comunicacao_wpp.map(contrato => contrato.telefone_instancia || contrato.telefone_celular).join(', ')
                  notification(AlertTypes.SUCCESS, `O contrato para assinatura será enviado via WhatsApp.\n Telefone: ${telefoneCliente}.`)
                })
              } catch (e) {
                const data = e.response && e.response.data ? e.response.data : {}
                const errorMessage = data.message || data.error || ''
                const finalMessage = errorMessage || 'Não foi possível reenviar o contrato via WhatsApp.'

                notification(AlertTypes.ERROR, finalMessage)
              }
            }
          }

          if (Object.keys(buttons).length > 1) {
            alert({
              text: 'Como deseja reenviar o(s) contrato(s) para assinatura?',
              showCloseButton: true,
              buttons
            })
          } else {
            const [buttonText, buttonAction] = Object.entries(buttons)[0]
            alert({
              text: `Deseja reenviar o contrato para assinatura via ${buttonText}?`,
              showCloseButton: true,
              buttons: {
                'Fechar': () => true,
                'Sim': buttonAction
              }
            })
          }
        }
      },

      proximaHoraCheia () {
        let data = new Date()
        data.setMinutes(0)
        data.setSeconds(0)
        data.setMilliseconds(0)
        data.setHours(data.getHours() + 1)
        return data.getHours()
      },
      enviarContratos (contratos) {
        alert({
          text: 'Atenção! Deseja gerar e enviar o(s) contrato(s) ?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              await this.$http.post('/painel/contrato', { pedidos: contratos.map(contrato => contrato.id_pedido) })
              notification(AlertTypes.INFO, 'Contratos agendados para envio com sucesso!')
            }
          }
        })
      },
      liberarAssinatura (contrato) {
        alert({
          text: 'Deseja liberar a proposta ' + contrato.id_documento + ' da obrigatoriedade de assinatura?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              await this.$http.post('/painel/contrato/assinaturaobrigatoria', { id_documento: contrato.id_documento }).then(() => {
                notification(AlertTypes.SUCCESS, 'Proposta ' + contrato.id_documento + ' liberada para finalização sem obrigatoriedade de assinatura!')
                this.$refs.datatable.reload()
              }).catch(() => {
                notification(AlertTypes.ERROR, 'Não foi possível executar esta ação, tente novamente mais tarde')
              })
            }
          }
        })
      },
      alterarStatusPedidoAlocado (contrato, status) {
        alert({
          text: 'Deseja alterar o status da proposta ' + contrato.id_documento + ' para ' + StatusPedidoDesc[status] + '?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              await this.$http.post('/painel/contrato/status_pedido_alocado', { id_documento: contrato.id_documento, status })
              notification('info', 'Proposta ' + contrato.id_documento + ' alterado status para ' + StatusPedidoDesc[status])
              this.$refs.datatable.reload()
            }
          }
        })
      },
      checarAlocacao (contrato) {
        alert({
          text: 'Deseja alterar buscar o status de alocação da proposta ' + contrato.id_documento + '?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              await this.$http.post('/contrato/atualiza_alocacao', { id_pedido: contrato.id_pedido }).then((response) => {
                this.$refs.datatable.reload()
                notification(AlertTypes.SUCCESS, response.data.msg)
              }).catch(() => {
                notification(AlertTypes.ERROR, 'Ocorreu um erro ao verificar o status da alocação! Tente novamente em instantes.')
              })
            }
          }
        })
      },
      async buscarStatusContrato (contrato) {
        const res = await this.$http.get(`/painel/status_contrato/${contrato.hash_contrato}`)
        if (res.data.success) {
          notification(AlertTypes.SUCCESS, res.data.msg)
          this.$refs.datatable.reload()
        } else {
          notification(AlertTypes.ERROR, res.data.msg)
        }
      },
      recriarContrato (contrato) {
        alert({
          text: 'Atenção! Deseja gerar um novo contrato para a proposta ' + contrato.id_documento + '? O contrato atual será cancelado!',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              await this.$http.post('/painel/contrato/recriar_contrato', { hash_contrato: contrato.hash_contrato, id_pedido: contrato.id_pedido }).then(
                res => {
                  if (res.data.success) {
                    notification(AlertTypes.INFO, 'Processo de recriação do contrato agendado com sucesso.')
                  } else {
                    notification(AlertTypes.ERROR, `Falha no agendamento do processo de recriar de contrato. ${res.data.error}`)
                  }
                }
              )
            }
          }
        })
      },
      async excluirRascunho (item) {
        alert({
          text: 'Tem certeza de que deseja excluir? Essa ação não poderá ser desfeita',
          buttons: {
            'Cancelar': () => true,
            'Excluir': async () => {
              try {
                const url = item.id_carrinho
                  ? `/proposta/excluir/carrinho/${item.id_carrinho}`
                  : `/proposta/excluir/${item.id_pedido}`

                await this.$http.delete(url)

                notification(AlertTypes.SUCCESS, 'Rascunho excluído com sucesso!')
                this.$refs.datatable.reload()
              } catch (error) {
                if (error.response?.data?.has_credit_analysis) {
                  notification(AlertTypes.ERROR, 'O item em questão já passou pela Análise de Crédito, por isso, não será possível apagá-lo!')
                  return
                }

                notification(AlertTypes.ERROR, `Não foi possível excluir o rascunho em questão, por favor, tente novamente mais tarde! Mensagem retornada: ${error.response.data.message}`)
              }
            }
          }
        })
      },
      vincularContrato (contrato) {
        alert({
          text: `Atenção! Deseja vincular um novo contrato para a proposta ${contrato.id_documento}? O contrato atual será cancelado!`,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => {
              this.exibir_vincular_contrato = true
              this.hash_contrato_antigo = contrato.hash_contrato
              this.id_pedido_vincular_contrato = contrato.id_pedido
            }
          }
        })
      },
      async exportarExcel () {
        const endpoint = this.somenteRascunho
          ? `${this.ws}/contrato/exportar-rascunhos`
          : `${this.ws}/contrato/exportar`

        const headersWithoutActions = this.headers.filter(header => header.value && header.value !== 'actions')

        const encoded_params = Qs.stringify({
          filter: this.filter,
          custom_filter: this.customFilter,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          filtroExcel: { ...this.filter, ...this.customFilter },
          id_documento: this.idDocumento,
          headers: headersWithoutActions.map(header => header.value),
          headers_formatado: headersWithoutActions.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        try {
          window.open(`${endpoint}?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, 'Não foi possível baixar o relatório devido à quantidade de dados inclusa na requisição. Por favor, utilize filtros para gerar relatórios mais concisos e objetivos.')
        }
      },
      aplicarAlteracoesVisualizacao () {
        Object.assign(this.campos_usuario, this.campos_alterar_visualizacao)
        this.aba_visualizacao_visivel = false
        this.montarHeader(this.campos_usuario)
        this.salvarConfiguracaoCampos()
      },
      restaurarVisualizacao () {
        Object.keys(this.campos_usuario).forEach((key) => {
          this.campos_usuario[key] = true
          this.aba_visualizacao_visivel = false
        })
        this.montarHeader(this.campos_usuario)
        this.salvarConfiguracaoCampos()
      },
      async carregarCamposUsuario () {
        try {
          const tipoListagem = this.somenteRascunho ? 'rascunhos' : 'contratos'
          const endpoint = tipoListagem === 'rascunhos' ? '/painel/rascunho/campos_usuario' : '/painel/contrato/campos_usuario'
          const res = await this.$http.get(endpoint)
          Object.assign(this.campos_usuario, res.data)
          this.montarHeader(res.data)
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível carregar a configuração de campos da tabela')
        }
      },
      async salvarConfiguracaoCampos () {
        try {
          const tipoListagem = this.somenteRascunho ? 'rascunhos' : 'contratos'
          const endpoint = tipoListagem === 'rascunhos' ? '/painel/rascunho/campos_usuario' : '/painel/contrato/campos_usuario'
          await this.$http.post(endpoint, this.campos_usuario, { options: { silent: true } })
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível salvar a configuração de campos da tabela')
        }
      },
      getStatusVenda (status_pedido) {
        return StatusPedidoDesc[status_pedido] ?? status_pedido
      },
      getStatusPagamento (status_pedido) {
        return verifyIfPaidAndReturnInText(status_pedido) ?? status_pedido
      },
      getTipoCotaText (cd_tipo_cota, tipo_cota) {
        if (cd_tipo_cota) {
          return cd_tipo_cota + ' - ' + tipo_cota
        }
        return '-'
      },
      getFormasPagamento (forma_pagamento) {
        if (!forma_pagamento || forma_pagamento.trim() === '') {
          return '-'
        } else {
          return FormasPagamentoDesc[forma_pagamento] ?? forma_pagamento
        }
      },
      montarHeader (item) {
        // Limpa o header para montar do zero novamente.
        const tempHeaders = [
          { text: 'Ações ', value: 'actions', class: 'sticky-column actions-column' }
        ]

        if (item.qtd_cotas_carrinho) {
          tempHeaders.push({ text: 'Qtd. cotas', value: 'qtd_cotas_carrinho' })
        }
        if (item.data_venda) {
          tempHeaders.push({ text: 'Data da venda', value: 'data_venda', class: `${this.somenteRascunho ? 'somente-rascunho' : ''}` })
        }

        if (!this.somenteRascunho) {
          // A coluna "Nº Proposta" sempre vai estar vísivel, por conta disso não possui um if para verificar.
          tempHeaders.push({ text: 'Nº Proposta', value: 'id_documento' })
        }

        if (item.id_carrinho) {
          tempHeaders.push({ text: 'ID Carrinho', value: 'id_carrinho' })
        }
        if (item.status_venda) {
          tempHeaders.push({ text: 'Status da venda', value: 'status_pedido' })
        }
        if (item.cotas_multiplas) {
          tempHeaders.push({ text: 'Cotas multiplicadas?', value: 'cotas_multiplas' })
        }
        if (item.status_alocacao) {
          tempHeaders.push({ text: 'Status da Cota', value: 'status_alocacao' })
        }

        if (item.status_contrato && !this.somenteRascunho) {
          tempHeaders.push({ text: 'Status do contrato ', value: 'status_contrato' })
        }

        if (item.hash_contrato && !this.somenteRascunho) {
          tempHeaders.push({ text: 'Id do contrato ', value: 'hash_contrato' })
        }

        if (item.nome_cliente) {
          tempHeaders.push({ text: 'Nome do cliente ', value: 'nome_cliente' })
        }

        if (item.cpf_cnpj_cliente) {
          tempHeaders.push({ text: 'CPF/CNPJ do cliente', value: 'cpf_cnpj_cliente' })
        }

        if (item.email_cliente) {
          tempHeaders.push({ text: 'E-mail do cliente', value: 'email_cliente' })
        }
        if (item.cd_cota) {
          tempHeaders.push({ text: 'N° da cota', value: 'cd_cota' })
        }

        if (item.grupo) {
          tempHeaders.push({ text: 'Grupo da cota', value: 'grupo' })
        }

        if (item.plano_venda) {
          tempHeaders.push({ text: 'Plano de venda', value: 'plano_venda' })
        }

        if (item.bem) {
          tempHeaders.push({ text: 'Bem', value: 'bem' })
        }

        if (item.valor_bem) {
          tempHeaders.push({ text: 'Valor do bem', value: 'valor_bem' })
        }
        if (item.tipo_cota) {
          tempHeaders.push({ text: 'Tipo de Cota', value: 'tipo_cota' })
        }

        if (item.pz_comercializacao) {
          tempHeaders.push({ text: 'Pz. de comercialização', value: 'pz_comercializacao' })
        }

        if (item.numero_reserva) {
          tempHeaders.push({ text: 'Nº da reserva', value: 'numero_reserva' })
        }

        if (item.negociacao_furo) {
          tempHeaders.push({ text: 'Negociação furo', value: 'negociacao_furo' })
        }

        if (item.forma_pagamento) {
          tempHeaders.push({ text: 'Forma de Pagamento', value: 'forma_pagamento' })
        }

        if (item.status_pagamento && !this.somenteRascunho) {
          tempHeaders.push({ text: 'Status do Pagamento', value: 'status_pagamento', sortable: false })
        }

        if (item.codigo_pagamento && !this.somenteRascunho) {
          tempHeaders.push({ text: 'Cod. pagamento', value: 'codigo_pagamento' })
        }

        if (item.perfil_comercial) {
          tempHeaders.push({ text: 'Hierarquia Comercial', value: 'perfil_comercial' })
        }
        if (item.id_usuario_venda) {
          tempHeaders.push({ text: 'Usuário', value: 'id_usuario_venda' })
        }
        if (item.cd_ponto_venda) {
          tempHeaders.push({ text: 'Código P.V', value: 'cd_ponto_venda' })
        }
        if (item.nm_ponto_venda) {
          tempHeaders.push({ text: 'Nome P.V', value: 'nm_ponto_venda' })
        }
        if (item.cpf_cnpj_pv) {
          tempHeaders.push({ text: 'CPF/CNPJ P.V', value: 'cpf_cnpj_pv' })
        }
        if (item.comissionado) {
          tempHeaders.push({ text: 'Comissionado', value: 'comissionado' })
        }
        if (item.backoffice) {
          tempHeaders.push({ text: 'Venda Backoffice', value: 'backoffice' })
        }
        if (item.empresa) {
          tempHeaders.push({ text: 'Empresa', value: 'empresa' })
        }

        if (item.marca) {
          tempHeaders.push({ text: 'Marca', value: 'marca' })
        }

        if (item.unidade_negocio) {
          tempHeaders.push({ text: 'Un. Negócio Logado', value: 'unidade_negocio' })
        }

        if (item.origem_venda) {
          tempHeaders.push({ text: 'Origem de Venda', value: 'origem_venda' })
        }
        if (item.origem_acesso) {
          tempHeaders.push({ text: 'Origem Acesso', value: 'origem_acesso' })
        }
        if (item.cd_simulacao_ed) {
          tempHeaders.push({ text: 'Cód. Simulador', value: 'cd_simulacao_ed' })
        }
        if (item.origem_assinatura_consorcio && !this.somenteRascunho) {
          tempHeaders.push({ text: 'Origem Contrato', value: 'origem_assinatura_consorcio' })
        }
        if (item.cd_plano_venda) {
          tempHeaders.push({ text: 'Cód. Plano de Venda', value: 'cd_plano_venda' })
        }
        if (item.tipo_indice) {
          tempHeaders.push({ text: 'Tipo de Índice', value: 'tipo_indice' })
        }
        if (item.categoria_plano) {
          tempHeaders.push({ text: 'Categoria do Plano', value: 'categoria_plano' })
        }
        if (item.tipo_grupo) {
          tempHeaders.push({ text: 'Tipo de Grupo', value: 'tipo_grupo' })
        }
        this.headers = tempHeaders

        this.loadFixedFields()
      },
      reload () {
        this.$refs.datatable.reload()
      },
      obterTextoContratoEngine (flag) {
        if (flag == null) {
          return TIPOS_PROVEDOR_CONTRATO_DESC.sem_provedor
        }
        return flag ? TIPOS_PROVEDOR_CONTRATO_DESC.assinatura_consorcio : TIPOS_PROVEDOR_CONTRATO_DESC.docusign
      },
      showMenuOptions (item) {
        return (!!item.row_num && !!item.id_carrinho) || this.possuiAcaoPropostaIndividual(item) || this.somenteRascunho
      }
    }
  }
</script>

<style>
.container_alterar_visualizacao {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
}
.listagem th {
    min-width: 190px;
}

.listagem th:nth-of-type(2) {
    min-width: fit-content;
}

.sticky-column {
    position: sticky;
    background: white;
}

.listagem td, .listagem th {
    padding: 0 35px;
}

.actions-column {
    left: 50px;
    width: 100px;
    min-width: 100px;
}

.sale-date-column {
    left: 150px;
    z-index: 9996;
    width: 150px;
    min-width: 150px;
}

.sale-date-column.somente-rascunho {
  border-right: 1px solid #ddd;
}

.proposal-number-column {
    left: 340px;
    z-index: 9995;
    width: 210px;
    min-width: 210px;
    border-right: 1px solid #ddd;
}

.no-sale-date .actions-column {
    left: 50px;
}

.fixed-column-0 {
    position: sticky;
    z-index: 10 !important;
    left: 50px;
    min-width: 100px;
    min-width: 100px;
    background-color: white;
}

.fixed-column-1 {
    position: sticky;
    z-index: 10 !important;
    left: 150px;
    width: 150px;
    min-width: 150px;
    background-color: white;
}

.fixed-column-2 {
    position: sticky;
    z-index: 10 !important;
    left: 300px;
    width: 150px;
    min-width: 150px;
    background-color: white;
}

.fixed-column-3 {
    position: sticky;
    z-index: 10 !important;
    left: 450px;
    width: 150px;
    min-width: 150px;
    background-color: white;
}

.no-sale-date .proposal-number-column {
    left: 150px;
}
</style>

<style scoped lang="scss">
.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
    padding: 0;
    min-width: 0;
    width: 48px;
    margin-right: 10px;
}

.botoes-acao .v-btn {
    flex: 1;
}

.tooltip-ajuda {
    height: 24px;
    position: relative;

    .tooltip-ajuda-text {
        position: absolute;
        background: #FFF;
        padding: 5px;
        border: 2px solid var(--primary);
        bottom: 100%;
        right: 0;
        z-index: -1;
        margin-bottom: 0;
        opacity: 0;
        transition: all ease 500ms !important;
    }

    &:hover .tooltip-ajuda-text {
        opacity: 1;
        z-index: 1;
    }
}

.listagem {
    overflow-x: auto;
    white-space: nowrap;

    $espacamento_scrollbar_vertical_top_tela_grande: 2.7rem;
    $espacamento_scrollbar_horizontal_responsiva: var(--marginScrollLeft);

    ::-webkit-scrollbar-track:vertical {
        margin-top: $espacamento_scrollbar_vertical_top_tela_grande;
    }
    @media (max-width: 1366px) {
        $espacamento_scrollbar_vertical_top_tela_media: 2.2rem;

        ::-webkit-scrollbar-track:vertical {
            margin-top: $espacamento_scrollbar_vertical_top_tela_media;
        }
    }
}
</style>

<style lang="scss">

.table-consultas-detalhadas .v-data-table__wrapper {
    max-height: 70vh;
}

.table-consultas-detalhadas .v-data-table__wrapper table thead tr {
    z-index: 2;
    position: sticky;
    background-color: var(--white);
    top: 0px !important;
}
</style>
